import { Box, Typography } from '@mui/material'
import { FieldError, UseFormSetValue } from 'react-hook-form'
import { Select } from 'utoniq-ui'

import { TicketItemExpirationTerm } from '@/clients/utoniq-core/schema'
import { CreateItemProps } from '@/components/pages/ConsoleItemCreate/template/ItemCreateForm'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type ExpirationDateInputCellProps = {
  value: string
  setValue: UseFormSetValue<CreateItemProps>
  error?: FieldError
}
export const ExpirationDateInputCell: Cell<ExpirationDateInputCellProps> = ({
  value,
  setValue,
  error,
}) => {
  const { t } = useTranslation('consoleItemCreate')
  return (
    <CellFrame sx={{ pb: 7 }}>
      <Typography variant="h5">{t('expirationDateLabel')}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ pt: 2 }}>
        {t('expirationDateDesc')}
      </Typography>
      <Box sx={{ pt: 3 }}>
        <Select
          listItems={[
            { value: 'unlimited', label: t('unlimited') },
            { value: TicketItemExpirationTerm.Halfyear, label: t('6months') },
            { value: TicketItemExpirationTerm.Oneyear, label: t('1year') },
          ]}
          value={value || 'unlimited'}
          onChange={value =>
            setValue(
              'metadata.ticket.expirationTerm',
              (value === 'unlimited' ? null : value) as never
            )
          }
          error={!!error}
          helperText={error?.message}
          placeholder={t('metadata.ticket.expiredAtPlaceholder')}
          formControlProps={{
            sx: { width: '100%', bgcolor: 'grey.50', minHeight: 'auto' },
          }}
        />
      </Box>
    </CellFrame>
  )
}
